<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 网站管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>新闻资讯</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-select v-model="query.articleType" placeholder="请选择资讯类型">
                    <el-option key="" label="请选择资讯类型" value=""></el-option>
                    <el-option v-for="item in articleTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
                </el-select>&nbsp;
				<el-input v-model="query.title" placeholder="标题" class="handle-input mr10"></el-input>
                <el-date-picker
					type="datetime"
					placeholder="开始时间"
					v-model="query.createTimeStart"
					value-format="yyyy-MM-dd HH:mm:SS"
				></el-date-picker> &nbsp;
				<el-date-picker
					type="datetime"
					placeholder="结束时间"
					v-model="query.createTimeEnd"
					value-format="yyyy-MM-dd HH:mm:SS"
				></el-date-picker>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				<el-button type="primary" icon="el-icon-download" @click="handleExport" v-if = "controll['export']">导出</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="articleType" label="类型" :formatter="articleTypeFormat"></el-table-column>
                <el-table-column prop="title" label="标题"></el-table-column>
				<el-table-column prop="showTimes" label="点击量"></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if = "controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if = "controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if = "controll['delete-batch']"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if = "controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog :title="title" :visible.sync="editVisible" width="60%">
            <el-form ref="form" :model="form" label-width="90px" :rules="rules">
				<el-form-item label="资讯类型" prop="articleType">
					<el-select v-model="form.articleType" placeholder="请选择资讯类型">
						<el-option key="" label="请选择资讯类型" value=""></el-option>
						<el-option v-for="item in articleTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="资讯标题" prop="title">
					<el-input v-model="form.title"></el-input>
				</el-form-item>
				<el-form-item label="资讯简报" prop="brief">
					<el-input type=textarea :rows=3 v-model="form.brief"> </el-input>
				</el-form-item>
				<el-form-item label="图片" prop="img">
					<el-upload
						class="upload-demo"
						multiple = false
						:before-upload="beforeUpload"
						:action= "uploadUrl"
						:on-success="uploadSuccess"
						:on-remove="handleRemove"
						:file-list="fileList"
						accept=".png,.jpg,.bmp"
						list-type="picture">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过1M</div>
					</el-upload>
				</el-form-item>
				<quill-editor ref="contentEditor" v-model="form.content" :options="contentOption"></quill-editor>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchNewsData, saveNews, getNews, deleteNews, getEnumValueKV, exportNews } from '../../../api/index';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import {quillRedefine} from 'vue-quill-editor-upload'
export default {
    name: 'news',
    data() {
        return {
            query: {
                pageIndex: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			articleTypeKV:[],
			articleTypeCode:1005,
			title:"",
			rules: {
                articleType: [{ required: true, message: '请选择资讯类型', trigger: 'blur' }],
                title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				brief: [{ required: true, message: '简报不能为空', trigger: 'blur' }],
				img: [{ required: true, message: '图片不能为空', trigger: 'blur' }]
            },
			uploadUrl : "/image/upload/18",
			fileList:[],
			imgPrefix:"/image",
			controll:{}
        };
    },
    created() {
		this.controll = getControll("news");
		let ckey = localStorage.getItem('ms_ckey');
		this.uploadUrl = "/image/upload/" + ckey + "/18";
		this.getArticleTypes();
        this.getData();
		this.contentOption = quillRedefine({
			// 图片上传的设置
			uploadConfig: {
				action: "/image/upload/" + ckey + "/12",  // 必填参数 图片上传地址
				res: (respnse) => {
					return this.imgPrefix + respnse.data
				},
				methods: 'POST',  // 可选参数 图片上传方式  默认为post
				//token: sessionStorage.token,  // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
				name: 'img',  // 可选参数 文件的参数名 默认为img
				size: 2048,  // 可选参数   图片限制大小，单位为Kb, 1M = 1024Kb
				accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',  // 可选参数 可上传的图片格式
				placeholder: '产品描述',  // 可选参数 富文本框内的提示语
				//theme: '',  // 可选参数 富文本编辑器的风格
				//toolOptions: [],  // 可选参数  选择工具栏的需要哪些功能  默认是全部
				//handlers: {}  // 可选参数 重定义的事件，比如link等事件
			}
		})
    },
	components: {
		quillEditor,
		quillRedefine
	},
    methods: {
		articleTypeFormat(row, column, cellValue) {
			let index = this.articleTypeKV.findIndex(item => {
				if (item.key == cellValue) {
					return true;
				}
			});
			
			return this.articleTypeKV[index].value;
		},
		getArticleTypes() {
			getEnumValueKV(this.articleTypeCode).then(res => {
                if (res.code == 0 ) {
					this.articleTypeKV = res.data;
				} else {
					this.$message.error("获取资讯类型失败！" + res.message);
				}
            });
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchNewsData(this.query).then(res => {
                if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取资讯数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
			this.$set(this.query, 'pageNum', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteNews([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteNews(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
        //添加操作
		handleAdd() {
			this.form = {};
			this.fileList = [];
			this.title = "添加新纪录";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
			this.title = "编辑";
			this.fileList = [];
			getNews(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
					if (typeof(res.data.img) != "undefined") {
						let json = {};
						json['url'] = this.imgPrefix + res.data.img;
						this.fileList.push(json);
					}
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveNews(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								this.$set(this.tableData, this.idx, this.form);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		//文件上传
		uploadSuccess(response, file, fileList) {
			this.form.img = response.data;
		},
		//删除图片
		handleRemove(file, fileList) {
			if (!this.form.img) {
				return;
			}
			removeImg([this.form.img]).then(res => {
				if (res.code == 0 ) {
					this.$message.success("删除图片成功");
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		handleExport() {
			exportNews().then(res => {
				if (res.code == 0) {
					this.$message.success(`生成XML数据成功！`);
					var linkTag = document.createElement("a");
					linkTag.href = "/blob/export/download-xml?key=" + res.data;			
					linkTag.click();
					linkTag.remove();
				} else {
					this.$message.error(`导出失败！` + res.message);
				}
			})
		},
		beforeUpload(file){
			let limit = file.size / 1024 < 1024;
			if (!limit) {
			  this.$message.error('上传文件大小不能超过 1M');
			  return false;
			}
			return true;
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
